import { render } from "./Reference.vue?vue&type=template&id=d42344f4&scoped=true&ts=true"
import script from "./Reference.vue?vue&type=script&lang=ts"
export * from "./Reference.vue?vue&type=script&lang=ts"

import "./Reference.vue?vue&type=style&index=0&id=d42344f4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42344f4"]])

export default __exports__